/**
 * Procedure Categories and Procedures for MD in Pathology students
 * Extracted with strict evidence from official NMC PDF
 */
export const PATHOLOGY_MD_PROCEDURES = {
  "Surgical Pathology & Histotechnology": [
    "Surgical Specimen Grossing & Tissue Sectioning",
    "Paraffin Block Making & Rotary Microtome Section Cutting",
    "Hematoxylin and Eosin (H&E) & Special Staining",
    "Frozen Section Cutting on Cryostat & Rapid Staining",
    "Manual Immunohistochemistry (IHC) Staining",
  ],
  "Cytopathology Procedures": [
    "Fine Needle Aspiration Cytology (FNAC) of Superficial Lumps",
    "Cytological Smear Preparation, Fixation & Staining (PAP / Giemsa)",
    "On-Site Adequacy Assessment for Image-Guided Biopsies & Cell Block Preparation",
  ],
  "Hematology & Bone Marrow Interventions": [
    "Venipuncture & Peripheral Blood Smear Preparation / Staining",
    "Bone Marrow Aspiration & Trephine Biopsy",
    "Bone Marrow Iron Staining & Cytochemical Staining for Leukemia",
    "Coagulation Testing (PT, APTT, FDP, D-Dimer)",
    "Sickling Test & Osmotic Fragility Test",
  ],
  "Clinical Pathology & Laboratory Medicine": [
    "Urinalysis (Physical, Chemical & Microscopic Sediment Examination)",
    "Stool Macroscopic & Microscopic Examination for Ova and Cysts",
    "CSF, Pleural, and Peritoneal Fluid Analysis",
    "Semen Analysis & Sperm Morphology",
    "Preparation of Laboratory Standard Solutions, Reagents, and Buffers",
  ],
  "Autopsy Pathology": [
    "Clinical Autopsy & Organ Complex Dissection",
  ],
};

export const PATHOLOGY_MD_CATEGORIES = Object.keys(PATHOLOGY_MD_PROCEDURES);

export const isMDInPathologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (d.includes("md") || d.includes("master")) &&
    d.includes("pathology") &&
    !d.includes("clinical pathology")
  );
};
